import React, { useState, useEffect } from 'react';
import { formatInTimeZone, utcToZonedTime, format } from 'date-fns-tz';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Chart from './../../components/dashboard/Chart';
import Deposits from './../../components/dashboard/Deposits';
import Orders from './../../components/dashboard/Orders';

import { StreamApp, StatusUpdateForm, FlatFeed, NotificationDropdown } from 'react-activity-feed';
import 'react-activity-feed/dist/index.css';

import { useAppDispatch, useAppSelector } from '../../hooks';
import authAccount, { cognitoSignOut } from '../../managers/redux/slices/authAccount';
import ProfileAvatar from '../../components/data-display/ProfileAvatar';

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Flourish, LLC
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

function DashboardContent() {

  const communicationsProfile = useAppSelector(state => state.authAccount.communicationsProfile)
  const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

  return (
    <div>
      <CssBaseline />
      <Toolbar />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mb-5">
            <div className="d-flex flex-row justify-content-between align-items-center">
              <Typography variant="h2">Dashboard</Typography>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-start align-items-start bg-white rounded py-3" style={{ overflowY: 'scroll', maxHeight: '75vh' }}>
              <Typography variant="h4" className="mb-2 px-3">Recent transactions</Typography>
              <Orders />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-start align-items-start bg-white rounded" style={{ overflowY: 'scroll', maxHeight: '75vh' }}>
              <div className="w-100 bg-white p-3 d-flex flex-row justify-content-start align-items-center">
                <Typography variant="h4" className="mb-2 px-3">Recent activity</Typography>
              </div>
              {
                selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.streamJwt &&
                <StreamApp
                  apiKey="ax9qpj459r9x"
                  appId="1170890"
                  token={selectedStaffProfile.organization.streamJwt}
                >
                  {/* <StatusUpdateForm userId={selectedStaffProfile.organization.id} /> */}
                  <FlatFeed feedGroup="latent_interactions" notify userId={selectedStaffProfile.organization.id} Activity={(activity) => {
                    console.log(activity)
                    return (
                      <div className="w-100 px-3">
                        <div className="d-flex flex-row justify-content-start align-items-center bg-light border rounded my-3 p-4">
                          {
                            activity.activity && activity.activity.authAccountID ?
                              /* @ts-ignore */
                              <ProfileAvatar authAccountID={activity.activity.authAccountID ? activity.activity.authAccountID : null} size="large" />
                              :
                              <div />
                          }
                          <div className="d-flex flex-column justify-content-center align-items-start mx-3">
                            {/* @ts-ignore */}
                            <Typography variant="h5">{activity.activity.campaignName && typeof activity.activity.campaignName == 'string' ? activity.activity.campaignName : ''}</Typography>
                            {/* @ts-ignore */}
                            <Typography variant="body1">{activity.activity.object}</Typography>
                            {/* @ts-ignore */}
                            <Typography variant="caption">{new Date(activity.activity.time + 'Z').toLocaleString()}</Typography>
                          </div>
                        </div>
                      </div>
                    )
                  }} />
                </StreamApp>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}